<div class="sidenav-content-wrapper" [formGroup]="quickFiltersForm">
    <div class="sidenav-header">
        <h3 class="tw-text-lg tw-font-semibold tw-tracking-tight tw-my-0">{{'EXTENDED_TABLE.TITLE.QUICK_FILTER' | translate}}</h3>
        <div>
            @if(filterApplied && !hideResetFilterIcon) {
                <button mat-icon-button (click)="resetQuickFilter(true)" aria-label="Reset quick filters">
                    <mat-icon>filter_alt_off</mat-icon>
                </button>
            }
            <button mat-icon-button (click)="toggleSidenav()" aria-label="Close filter sidenav">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    @if(formReady) {
        <div class="sidenav-section single-section">
            @for (filter of quickFilters; track $index) {
                <div>
                    <h4 class="title-section">{{filter.name}}</h4>
                    <div [formGroupName]="filter.field" class="tw-pb-4">
                        <div class="checkbox-list" formArrayName="options">
                            @for(option of getOptionsQuickFilterFormArray(filter.field).controls; track option) {
                                <div [formGroupName]="$index" class="checkbox-wrapper">
                                    <mat-checkbox formControlName="selected" (change)="checkboxQuickFilterSelectionChange($event)">
                                    {{ option.get('value')?.value }}
                                    </mat-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    }
    <!-- <div class="sidenav-section bottom-section">
        <button mat-stroked-button (click)="resetQuickFilter(true)">Azzera</button>
    </div> -->
</div>